import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=2f554546&scoped=true"
import script from "./Services.vue?vue&type=script&lang=ts"
export * from "./Services.vue?vue&type=script&lang=ts"
import style0 from "./Services.vue?vue&type=style&index=0&id=2f554546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f554546",
  null
  
)

export default component.exports